import React from 'react';
import Badge from './Badge';
import { useOptions } from '../../hooks/useOptions';
import * as HeroIcons from '@heroicons/react/24/outline';

/**
 * Dynamic Badge Component
 * Renders a badge with label and variant fetched from configuration
 * 
 * @param {string} optionType - Type of options (e.g., 'articleStatus', 'contactPriority')
 * @param {any} value - Value to display
 * @param {boolean} dot - Show dot indicator
 * @param {boolean} showIcon - Show icon if available
 * @param {string} className - Additional CSS classes
 */
const DynamicBadge = ({ optionType, value, dot = false, showIcon = false, className = '' }) => {
  const { getLabel, getVariant, getIcon, loading } = useOptions(optionType);

  if (loading) {
    return <Badge variant="secondary">Loading...</Badge>;
  }

  const label = getLabel(value);
  const variant = getVariant(value);
  const iconName = showIcon ? getIcon(value) : null;

  // Get icon component if icon name is provided
  let IconComponent = null;
  if (iconName && HeroIcons[iconName]) {
    IconComponent = HeroIcons[iconName];
  }

  return (
    <Badge variant={variant} dot={dot} className={className}>
      {IconComponent && (
        <IconComponent className="w-3 h-3 mr-1 inline-block" />
      )}
      {label}
    </Badge>
  );
};

export default DynamicBadge;
